<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="2000px "
    
    v-model="show"
    fullscreen
  >
    <template v-slot:default="dialog">
      <v-container>
        <v-row justify="space-around">
          <v-card max-height="3000px">
            <v-row>
              <v-col width="300px">
                <v-img height="200px" :src="perfil.picture.large"> </v-img>
              </v-col>
              <v-col width="300px"> 
                <l-map
                  
                  :zoom="zoom"
                  :center="markerLatLng"
                >
                  <l-tile-layer
                    :url="url"
                    :attribution="attribution"
                  ></l-tile-layer>
                  <l-marker :lat-lng="markerLatLng"></l-marker>
                </l-map>
             
                <v-btn elevation="2" outlined @click="addFavorite(perfil)">
                  <v-icon>mdi-heart</v-icon>
                  Agregar a Favoritos</v-btn
                >
                <h3 v-if="favorite">Favorito!</h3>
                <v-btn elevation="2" outlined @click="deleteFavorite(perfil)">
                  <v-icon>mdi-heart</v-icon>
                  Eliminar de Favoritos</v-btn
                >
                <h3 v-if="noFavorite">Eliminado de Favoritos</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card-text>
                  <h2 class="ml-3">
                    {{ perfil.name.first + " " + perfil.name.last }}
                  </h2>
                  <v-card-title class="white--text mt-8">
                    <p class="ml-3">
                      {{ perfil.name.first + " " + perfil.name.last }}
                    </p>
                  </v-card-title>
                  <p class="font-weight-bold ml-8 mb-2">{{ perfil.email }}</p>
                  <p class="font-weight-bold ml-8 mb-2">
                    City: {{ perfil.location.city }}
                  </p>
                  <p class="font-weight-bold ml-8 mb-2">
                    Location:
                    {{
                      perfil.location.street.name +
                      " " +
                      perfil.location.street.number
                    }}
                  </p>
                  <p class="font-weight-bold ml-8 mb-2">
                    Tel: {{ perfil.cell }}
                  </p>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn text @click="dialog.value = false">Close</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card>
        </v-row>
      </v-container>
    </template>
  </v-dialog>
</template>
<script>
import L from 'leaflet';
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import FavoritStore from "../store/favoritosStore";
import { Icon } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  data() {
    return {
      dialog: true,
      markerLatLng: [
        Number(this.perfil.location.coordinates.latitude),
        Number(this.perfil.location.coordinates.longitude),
      ],
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 13,
      favorite: false,
      noFavorite: false,
    };
  },
  props: ["visible", "perfil"],
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  created() {
    console.log(this.markerLatLng);
  },
  methods: {
    addFavorite(person) {
      FavoritStore.methods.addFavorite(person);
      this.favorite=true
    },
    deleteFavorite(person) {
      FavoritStore.methods.deleteFavorite(person);
      this.favorite=false
      this.noFavorite=true
    },
    close() {
      this.dialog = false;
      this.$emit("close");
      this.dialog = true;
    },
  },
};
</script>
